import { AnyIfEmpty } from 'react-redux';
import {
    GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_REQUEST,
    GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_SUCCESS,
    GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_FAILURE,
    CLEAR_VENDOR_APPOINTMENTS_STATE,
} from '../constants/vendorAppointments.constant';

// Initial state for vendor appointments
const initialState = {
    vendorAppointments: {
        loading: false,
        data: null,
        error: '',
    },
    accessCodeValidation: {
        loading: false,
        isValid: false,
        error: '',
    },
};

const vendorAppointmentsReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_REQUEST:
            return {
                ...state,
                vendorAppointments: {
                    ...state.vendorAppointments,
                    loading: true,
                    data: null,
                    error: '',
                },
                accessCodeValidation: {
                    ...state.accessCodeValidation,
                    loading: true,
                    error: '',
                },
            };

        case GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_SUCCESS:
            return {
                ...state,
                vendorAppointments: {
                    ...state.vendorAppointments,
                    loading: false,
                    data: action.payload,
                    error: '',
                },
                accessCodeValidation: {
                    ...state.accessCodeValidation,
                    loading: false,
                    isValid: Array.isArray(action.payload) && action.payload.length > 0,
                    error: '',
                },
            };

        case GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_FAILURE:
            return {
                ...state,
                vendorAppointments: {
                    ...state.vendorAppointments,
                    loading: false,
                    data: null,
                    error: action.payload,
                },
                accessCodeValidation: {
                    ...state.accessCodeValidation,
                    loading: false,
                    isValid: false,
                    error: action.payload,
                },
            };

        case CLEAR_VENDOR_APPOINTMENTS_STATE:
            return {
                ...state,
                vendorAppointments: {
                    loading: false,
                    data: null,
                    error: '',
                },
                accessCodeValidation: {
                    loading: false,
                    isValid: false,
                    error: '',
                },
            };

        default:
            return state;
    }
};

export default vendorAppointmentsReducer;
